import { svg } from 'lit';
import { type IconBase, createIconComponent } from '../Icon.component';

/** List of icons here : https://lamaille.supernova-docs.io/latest/foundations/iconography-system-xiZRSP4Z#search-7b7542c0-4d44-11ec-8ce5-cb0f56bcf344 **/
export const IconClose = createIconComponent(
    'lr-icon-close',
    svg`
<path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M9.00015 7.58594L9.70726 8.29304L16.0003 14.586L22.2932 8.29304L23.0004 7.58594L24.4146 9.00015L23.7075 9.70726L17.4145 16.0003L23.7073 22.293L24.4144 23.0002L23.0002 24.4144L22.293 23.7073L16.0003 17.4145L9.70746 23.7073L9.00035 24.4144L7.58614 23.0002L8.29325 22.293L14.586 16.0003L8.29304 9.70726L7.58594 9.00015L9.00015 7.58594Z" fill="currentcolor"/>
`
);

declare global {
    interface HTMLElementTagNameMap {
        'lr-icon-close': IconBase;
    }
}
